<div class="favorite-list">
    <div class="header">
        <div class="dotdotdot" (click)="onOpenMenu.emit(favoriteListId())" (clickOutside)="onCloseMenu.emit(favoriteListId())">
            <ng-content></ng-content>
        </div>
        @if (selectedFavoriteListStore.editName()) {
            <div class="edit-mode">
                <div class="row1">
                    <div class="favorite-name">
                        <div class="input-field-wrapper">
                            <div class="input-wrapper">
                                <input
                                    #nameInput
                                    type="text"
                                    placeholder="Tittel på liste"
                                    [formField]="favoriteListForm.name"
                                    (change)="favoriteListForm.name().value.set($any($event.target).value.replace(/ /g, ' '))"
                                    (focus)="onNameFocus()"
                                    (keyup.enter)="updateName()"
                                    (blur)="updateName()"
                                    (clickOutside)="onNameClickOutside()"
                                />
                                @if (showCancelInput()) {
                                    <div
                                        class="cancelInput"
                                        [class.align-right]="!textAlignRight"
                                        [class.align-left]="textAlignRight"
                                        (mousedown)="resetText()"
                                    ></div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } @else {
            <div class="static-mode">
                <div class="row1">
                    <div class="favorite-name" [title]="selectedFavoriteListStore.name()">{{ selectedFavoriteListStore.name() }}</div>
                    @if (this.favoriteListDataService.loadingFavoriteListSignal()) {
                        <div class="loader"><ev-logo-loader variant="dots" width="24px" /></div>
                    }
                </div>
                <div class="row2">
                    <span>{{ selectedFavoriteListStore.createdDate() | date: "dd.MM.yyyy" }}</span>
                    <span>ref #{{ favoriteListId() | minLength: 6 }}</span>
                </div>
            </div>
            <div class="close" (click)="onClose.emit(favoriteListId())"></div>
        }
    </div>
    <div class="storing-status">
        <div class="status" [class.saved]="selectedFavoriteListStore.filters()" [class.changed]="selectedFavoriteListStore.filtersChanged()">
            <div class="filter-status">
                <div class="icon"></div>
                Filteroppsett
            </div>
            <div class="status-icon"></div>
        </div>
        <div class="status" [class.saved]="areaIsSaved() || polygonIsSaved()" [class.changed]="areaIsChanged() || polygonIsChanged()">
            <div class="area-status">
                <div class="icon"></div>
                Områder
            </div>
            <div class="status-icon"></div>
        </div>
        <div class="status" [class.saved]="propertyIsSaved()" [class.changed]="propertyIsChanged()">
            <div class="property-status">
                <div class="icon"></div>
                Enkelteiendommer
            </div>
            <div class="status-icon"></div>
        </div>
    </div>
    <div class="save-indicator">
        <div
            class="favorite-button"
            [class.disabled]="!selectedFavoriteListStore.canSave()"
            (click)="onSaveList()"
        >
            Lagre endringer
        </div>
        @if (this.selectedFavoriteListStore.tooManyUnits()) {
            <p>Flere enn 500 eiendommer i liste</p>
        }
    </div>
    <div class="content" [class.is-empty]="emptyFavoriteList()">
        <ev-accordion [initExpanded]="true" [animationFast]="true" [accordionHeight]="32" [buttonSize]="18" [buttonTopMargin]="7">
            <div header>
                <div class="subheader">
                    <div class="subheader-text">Områder</div>
                    <div class="subheader-counter">{{ nrOfAreas() }}</div>
                </div>
            </div>
            <div body>
                @for (area of favoriteAreas(); track area; let index = $index) {
                    <area-list-item [area]="area" (onRemove)="removeArea($event)"></area-list-item>
                }
                @for (polygon of favoritePolygons(); track polygon; let index = $index) {
                    <drawn-list-item [polygon]="polygon" (onRemove)="removePolygon($event)"></drawn-list-item>
                }
            </div>
        </ev-accordion>
        <ev-accordion [initExpanded]="true" [animationFast]="true" [accordionHeight]="32" [buttonSize]="18" [buttonTopMargin]="7">
            <div header>
                <div class="subheader">
                    <div class="subheader-text">Enkelteiendommer</div>
                    <div class="subheader-counter">{{ selectedFavoriteListStore.numberOfUnits() }}</div>
                </div>
            </div>
            <div body>
                @if (selectedFavoriteListStore.numberOfUnits() > 1) {
                    <div class="sort-wrapper">
                        <div class="sort-header">Sorter på</div>
                        <div class="drop-down-wrapper">
                            <ev-dropdown-menu
                                #searchResultDropDownCmp
                                class="filter-dropdown"
                                [items]="filterOptions()"
                                [fromRight]="true"
                                [alwaysShow]="true"
                                [asDotted]="false"
                                [showHeader]="false"
                                [showSubInSelected]="true"
                                [useBoxShadow]="false"
                                [theme]="'monochrome'"
                                (onSelectedItem)="handleOnSelectedItemChange($event)"
                            >
                            </ev-dropdown-menu>
                        </div>
                    </div>
                }
                @if (this.favoriteListDataService.loadingPropertiesListSignal()) {
                    <div class="big-loader">
                        <ev-logo-loader variant="dots" width="24px" />
                    </div>
                } @else {
                    <!-- @else { @if (selectedFavoriteListStore.isNewDwelling()) { @for(item of sortedNewDwellings(); track item; let index = $index) { -->
                    <!-- <new-dwelling-list-item [item]="item"></new-dwelling-list-item>
                } } @else { -->
                    @for (item of sortedSales(); track item; let index = $index) {
                        <estate-sale-item [sale]="item"></estate-sale-item>
                    }
                }
                <!-- } }  -->
            </div>
        </ev-accordion>
        @if (!selectedFavoriteListStore.numberOfUnits()) {
            <div class="add-selection">
                <div class="favorite-button" (click)="onAddAllSelection.emit(favoriteListId())">
                    <div class="add-icon"></div>
                    Legg til alle fra utvalg
                </div>
            </div>
        }
    </div>
</div>
